/**
 * @generated SignedSource<<9da73ae4efde952769cfd2408dca49d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ComplexMenuDesktopMainNavigation_navigationItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ComplexMenuDesktopNavigationItem_navigationItem"
    }
  ],
  "type": "NavigationItem",
  "abstractKey": null
};

node.hash = "88858eea309fa90ddf16ac041a502fd0";

module.exports = node;
